import { InventorySearchEvents } from '@dealersites/inventory/events';

/**
 * @file
 * Customize the behavior of the SRP search filters.
 */

const dspFilters = document.getElementById('dsp-filters');

if (dspFilters) {
  // Hide any empty filters on page load.
  for (const container of dspFilters.querySelectorAll('[data-option-count="0"]')) {
    const wrapper = container.closest('.filter-visibility');
    wrapper.classList.add('hidden');
  }

  // Adjust filter visibility as the data changes.
  dspFilters.addEventListener(InventorySearchEvents.POST_SEARCH_FILTER_UPDATE, (e) => {
    const { filter } = e.detail;
    const { container } = filter;

    if (!'optionCount' in container.dataset) {
      return;
    }

    const optionCount = Number.parseInt(container.dataset.optionCount, 10);

    if (isNaN(optionCount)) {
      return;
    }

    const wrapper = container.closest('.filter-visibility');
    const isVisible = !wrapper?.classList.contains('hidden');
    const shouldShow = optionCount > 0;

    if (isVisible !== shouldShow) {
      wrapper.classList.toggle('hidden', !shouldShow);
    }

    console.groupEnd();
  });
}
